/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isString as r}from"../utils.js";import{hex as t}from"./hex.js";import{hsla as s}from"./hsla.js";import{rgba as e}from"./rgba.js";const o={test:r=>e.test(r)||t.test(r)||s.test(r),parse:r=>e.test(r)?e.parse(r):s.test(r)?s.parse(r):t.parse(r),transform:t=>r(t)?t:t.hasOwnProperty("red")?e.transform(t):s.transform(t)};export{o as color};
//# sourceMappingURL=index.js.map
